module.exports = __webpack_public_path__ + "static/media/BlackBear.svg";